// extracted by mini-css-extract-plugin
module.exports = {"error":"Graph_error__2jGJ1"};